// extracted by mini-css-extract-plugin
export default {"container":"DragAndDrop_container__O1OrJ","dragOverlay":"DragAndDrop_dragOverlay__Db+Is","active":"DragAndDrop_active__BsOPy","dropZone":"DragAndDrop_dropZone__qIcSV"};